import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo1/benitocarro.png";
import Imagen2 from "../../../images/modulo1/tareas.png";
import Imagen3 from "../../../images/modulo1/almuerzo.png";
import Imagen4 from "../../../images/modulo1/desayuno.png";
import Imagen5 from "../../../images/modulo1/benitosale.png";
import Imagen6 from "../../../images/modulo1/alcolegio.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo1 } from "../../../routes/Module1";
import Sidebar from "../Sidebar";
import InputNumber from "../../../components/InputNumber";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo1/Actividad4.mp3";

const Actividad4 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: 2 },
    ans2: { value: "", valid: "", correctValue: 5 },
    ans3: { value: "", valid: "", correctValue: 4 },
    ans4: { value: "", valid: "", correctValue: 1 },
    ans5: { value: "", valid: "", correctValue: 6 },
    ans6: { value: "", valid: "", correctValue: 3 },
  });
  const [answersText, setAnswersText] = useState({
    ans1: { value: "", valid: "", correctValue: "trabajar" },
    ans2: { value: "", valid: "", correctValue: "tarea" },
    ans3: { value: "", valid: "", correctValue: "abuelo" },
    ans4: { value: "", valid: "", correctValue: "la familia" },
    ans5: { value: "", valid: "", correctValue: "reúnen" },
    ans6: { value: "", valid: "", correctValue: "escuela" },
  });
  const infoUnidad = modulo1.content[0];
  const infoAct = modulo1.content[0].activities[3];
  const crumbs = [
    {
      title: modulo1.title,
      url: "/" + modulo1.url,
    },
    {
      title:
        modulo1.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo1.content[0].activities[4].name}`,
    linkNext: `${modulo1.url}/${modulo1.content[0].path}/${modulo1.content[0].activities[4].path}`,
    titlePrev: `${modulo1.content[0].activities[2].name}`,
    linkPrev: `${modulo1.url}/${modulo1.content[0].path}/${modulo1.content[0].activities[2].path}`,
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: Number(event.target.value) },
    });
  };
  const handleAnswersText = (event, name) => {
    event.preventDefault();
    setAnswersText({
      ...answersText,
      [name]: { ...answersText[name], value: event.target.value },
    });
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...answers, newAnswers });
    let newAnswersText = answersText;
    Object.keys(newAnswersText).forEach(
      (key) =>
        (newAnswersText[key]["valid"] =
          answersText[key]["correctValue"].toUpperCase() ===
          answersText[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswersText({ ...answersText, newAnswersText });
  };

  const metadata = {
    color: modulo1.color,
    title: `${modulo1.title} - ${infoAct.name}`,
    name: modulo1.title
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo1.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">Actividad 4</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>Todas las familias tienen una rutina.</li>
        <li>
          Completa las palabras que faltan en la rutina de la familia de Benito
          Guadalupe.
        </li>
        <li>
        Luego, ordena las imágenes para conocer la rutina de la familia Guadalupe.</li>
      </ul>
      <div className="row activities-content mt-5">
        <div className="col-md-10 col-xs-12 mb-5">
          <Card>
            <div className="d-flex justify-content-around">
              <div>tarea</div>
              <div>escuela</div>
              <div>La familia</div>
              <div>abuelo</div>
              <div>reúnen</div>
              <div>trabajar</div>
            </div>
          </Card>
        </div>

        
        <div className="col-lg-4 col-md-6 col-xs-12">
          <div className="d-flex align-items-center">
            <InputNumber
              answer={answers.ans1}
              onChangeInput={handleAnswers}
              name="ans1"
              max="6"
            />{" "}
            <div>
              El papá sale a{" "}
              <input
                type="text"
                value={answersText.ans1.value}
                onChange={(event) => handleAnswersText(event, "ans1")}
                className={"input-text-sm " + answersText.ans1.valid}
              />
            </div>
          </div>
          <img src={Imagen1} alt="Familia" className="img-fluid mb-4" />
        </div>
        <div className="col-lg-4 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center">
            <InputNumber
              answer={answers.ans2}
              onChangeInput={handleAnswers}
              name="ans2"
              max="6"
            />
            <div>
              Los niños hacen la{" "}
              <input
                type="text"
                className={"input-text-sm " + answersText.ans2.valid}
                value={answersText.ans2.value}
                onChange={(event) => handleAnswersText(event, "ans2")}
              />
            </div>
          </div>
          <img src={Imagen2} alt="Familia" className="img-fluid mb-4" />
        </div>
        <div className="col-lg-4 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center">
            <InputNumber
              answer={answers.ans3}
              onChangeInput={handleAnswers}
              name="ans3"
              max="6"
            />{" "}
            <div>
              Los niños almuerzan con el{" "}
              <input
                type="text"
                className={"input-text-sm " + answersText.ans3.valid}
                value={answersText.ans3.value}
                onChange={(event) => handleAnswersText(event, "ans3")}
              />
            </div>
          </div>
          <img src={Imagen3} alt="Familia" className="img-fluid mb-4" />
        </div>
        <div className="col-lg-4 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center">
            <InputNumber
              answer={answers.ans4}
              onChangeInput={handleAnswers}
              name="ans4"
              max="6"
            />
            <div>
              <input
                type="text"
                className={"input-text-sm " + answersText.ans4.valid}
                value={answersText.ans4.value}
                onChange={(event) => handleAnswersText(event, "ans4")}
              />{" "}
              toma desayuno.
            </div>
          </div>
          <img src={Imagen4} alt="Familia" className="img-fluid mb-4" />
        </div>
        <div className="col-lg-4 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center">
            <InputNumber
              answer={answers.ans5}
              onChangeInput={handleAnswers}
              name="ans5"
              max="6"
            />
            <div>
              Todos se{" "}
              <input
                type="text"
                className={"input-text-sm " + answersText.ans5.valid}
                value={answersText.ans5.value}
                onChange={(event) => handleAnswersText(event, "ans5")}
              />{" "}
              por la tarde.
            </div>
          </div>
          <img src={Imagen5} alt="Familia" className="img-fluid mb-4" />
        </div>
        <div className="col-lg-4 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center">
            <InputNumber
              answer={answers.ans6}
              onChangeInput={handleAnswers}
              name="ans6"
              max="6"
            />{" "}
            <div>
              Los niños van a la{" "}
              <input
                type="text"
                className={"input-text-sm " + answersText.ans6.valid}
                value={answersText.ans6.value}
                onChange={(event) => handleAnswersText(event, "ans6")}
              />
            </div>
          </div>
          <img src={Imagen6} alt="Familia" className="img-fluid mb-4" />
        </div>
  
      </div>
      <div className="d-flex w-100 justify-content-end mb-4">
        <button
          className={`btn btn-${modulo1.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>
      <ul>
        <li>Ahora piensa, ¿cómo es la rutina de tu familia?</li>
      </ul>
      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes. Lea las descripciones una
          por una y pregunte con qué palabra se deben completar. Después, ayude
          a establecer la secuencia de las acciones en el tiempo. Enfatice que
          todas las actividades benefician la convivencia de la familia. Luego
          conversen sobre sus respectivas rutinas.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
